<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="科研指标管理" name="first">
        <div class="collect" v-if="activeName === 'first'">
          <div style="display: flex">
            <el-input style="width: fit-content" placeholder="请输入关键字进行查询" v-model="fieldParams.Key"></el-input>
            <el-button @click="getFieldPageList()" type="primary">查询</el-button>
            <el-button
              @click="
                fieldParams.Key = '';
                getFieldPageList();
              "
              type="warning"
            >
              重置
            </el-button>
          </div>
          <div>
            <div class="window">
              <el-form ref="elForm" :model="formVal" label-width="100px">
                <el-form-item label="主键：">
                  <el-switch v-model="formVal.IsPrimarykey" />
                </el-form-item>
                <el-form-item label="源字段名：">
                  <el-input v-model="formVal.Name" size="small"></el-input>
                </el-form-item>
                <el-form-item label="字段编码：">
                  <el-input v-model="formVal.DataName" size="small"></el-input>
                </el-form-item>
                <el-form-item label="字段类型：">
                  <el-select v-model="formVal.DataType" size="small">
                    <el-option value="0" label="数值"></el-option>
                    <el-option value="1" label="文本"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input v-model="formVal.Remarks" size="small"></el-input>
                </el-form-item>
                <el-form-item label="来源：">
                  <el-select v-model="formVal.System" size="small">
                    <el-option v-for="o in SystemOptions" :value="o.value" :label="o.label" :key="o.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="绑定字段：">
                  <el-select v-model="formVal.SysDataName" size="small">
                    <el-option v-for="o in PatientOptions" :value="o.field" :label="o.desc" :key="o.field"></el-option>
                  </el-select>
                  <!-- <el-input v-model="formVal.System" size="small"></el-input> -->
                </el-form-item>
                <el-form-item label="数据来源：">
                  <el-input v-model="formVal.FunctionName" size="small"></el-input>
                </el-form-item>
              </el-form>
              <el-button @click="handleAddField" type="primary" v-if="flag === 0">添加</el-button>
              <el-button @click="handleEditField" type="primary" v-if="flag === 1">保存</el-button>
              <el-button
                @click="
                  clearParams();
                  flag = 0;
                "
                type="warning"
                v-if="flag === 1"
              >
                取消
              </el-button>
            </div>
            <div class="field">
              <el-table :data="fieldPageList" style="width: 100%; height: 68vh; overflow-y: auto" border>
                <el-table-column label="主键" width="70" align="center">
                  <template slot-scope="{ row }">
                    <el-checkbox :value="row.IsPrimarykey" :readonly="true"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column prop="Name" label="源字段名" align="center" />
                <el-table-column prop="DataName" label="字段编码" align="center" />
                <el-table-column prop="System" label="来源" align="center" />
                <el-table-column prop="DataType" label="字段类型" align="center">
                  <template #default="{ row }">
                    <span v-if="row.DataType === '0'">数值</span>
                    <span v-if="row.DataType === '1'">文本</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Remarks" label="备注" align="center" />
                <el-table-column prop="SysDataName" label="绑定字段" align="center" />
                <el-table-column label="编辑" align="center">
                  <template #default="{ row }">
                    <el-button type="primary" size="mini" @click="handleEdit(row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="handleRemove(row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="fieldParams.page"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
                style="margin-top: 10px"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="数据处理" name="second">
        <HandleData v-if="activeName === 'second'" />
      </el-tab-pane>
      <el-tab-pane label="数据接入报告" name="third">
        <SJJRBG v-if="activeName === 'third'" />
      </el-tab-pane>
      <el-tab-pane label="数据集" name="fourth">
        <ShuJuJi v-if="activeName === 'fourth'" />
      </el-tab-pane>
      <el-tab-pane label="月度填充率" name="fifth">
        <YDTCL v-if="activeName === 'fifth'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import dataCenterApi from '../../api/dataCenterNav';
import HandleData from './HandleData.vue';
import SJJRBG from './SJJRBG.vue';
import ShuJuJi from './ShuJuJi.vue';
import YDTCL from './YDTCL.vue';

export default {
  data() {
    return {
      activeName: 'first',
      formVal: {
        Name: '', //源字段名
        DataName: '', //字段编码
        System: '', //来源
        DataType: '', //字段类型
        Remarks: '', //备注
        SysDataName: '', //绑定字段
        IsPrimarykey: false //主键
      },
      SystemOptions: [
        { label: 'HIS', value: 'HIS' },
        { label: 'LIS', value: 'LIS' },
        { label: 'PACS', value: 'PACS' },
        { label: 'EMR', value: 'EMR' },
        { label: '手麻', value: '手麻' },
        { label: '重症', value: '重症' },
        { label: '移动护理', value: '移动护理' },
        { label: '生物样本', value: '生物样本' },
        { label: '随访', value: '随访' },
        { label: '检验', value: '检验' },
        { label: '心电', value: '心电' },
        { label: '病理', value: '病理' }
      ],
      PatientOptions: [],
      fieldPageList: [],
      fieldParams: {
        page: 1,
        rows: 10,
        Key: ''
      },
      total: 0,
      flag: 0, // 0新增 1编辑
      reportTotal: 0
    };
  },
  components: { HandleData, ShuJuJi, YDTCL, SJJRBG },
  methods: {
    // 获取映射字段列表
    async getFieldPageList() {
      let res = await dataCenterApi.getFieldPageList(this.fieldParams);
      this.fieldPageList = res.data.Data.rows;
      this.total = res.data.Data.total;
    },
    // 清空表单
    clearParams() {
      this.formVal = {
        Name: '', //源字段名
        DataName: '', //字段编码
        System: '', //来源
        DataType: '', //字段类型
        Remarks: '', //备注
        SysDataName: '', //绑定字段
        IsPrimarykey: false //主键
      };
    },
    // 获取绑定字段
    async getPatientAttributeList() {
      let res = await dataCenterApi.PatientAttributeList();
      this.PatientOptions = res.data;
    },
    // 新增映射字段
    async handleAddField() {
      let res = await dataCenterApi.addField(this.formVal);
      if (res.data.Status !== 1) return this.$message.error(res.data.Message);
      this.$message.success('添加成功!');
      this.clearParams();
      this.getFieldPageList();
    },
    handleSizeChange(limit) {
      this.fieldParams.rows = limit;
      this.getFieldPageList();
    },
    handleCurrentChange(page) {
      this.fieldParams.page = page;
      this.getFieldPageList();
    },
    // 编辑映射字段
    handleEdit(row) {
      this.flag = 1;
      this.formVal = JSON.parse(JSON.stringify(row));
    },
    async handleEditField() {
      let { data: res } = await dataCenterApi.editField(this.formVal);
      if (res.Status !== 1) return this.$message.error(res.Message);
      this.$message.success('编辑成功!');
      this.flag = 0;
      this.clearParams();
    },
    handleRemove(row) {
      this.$confirm('此操作将永久删除该字段, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let { data: res } = await dataCenterApi.removeField([row.Id]);
          if (res.Status !== 1) return this.$message.error(res.Message);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getFieldPageList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    handleQuery() {}
  },
  created() {
    this.getFieldPageList();
    this.getPatientAttributeList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;

  :deep(.el-tabs__content) {
    height: 90vh;

    & > div {
      height: 100%;
    }
  }

  .collect {
    & > div:not(.bottom_btn) {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 1vw;
      margin-top: 20px;

      .window,
      .field {
        width: 100%;
        border: 1px solid #d9dbe2;
        border-radius: 5px;
        padding: 10px;
        box-sizing: border-box;
      }

      .handle {
        display: grid;
        grid-template-columns: 0.5fr;
        grid-template-rows: repeat(6, 1fr);
        gap: 20px;
        justify-content: center;

        .el-button {
          margin-left: 0;
        }
      }
    }

    .bottom_btn {
      text-align: right;
      margin-right: 20px;
      margin-top: 30px;
    }
  }
}

:deep(.el-form-item__content) {
  width: 240px;
}

:deep(.el-dialog__title) {
  color: #fff !important;
}
</style>
